"use client";

import { useSectionViewEvent } from "@/hooks/use-section-view-event";
import { PI_SECTION } from "@/lib/analytics/schema";
import { TESTIMONIALS_COPY } from "@/lib/site-copy";

export function TestimonialsSection() {
  useSectionViewEvent({
    sectionId: "testimonials",
    sectionName: PI_SECTION.TESTIMONIALS.name,
    sectionPosition: PI_SECTION.TESTIMONIALS.position,
  });

  return (
    <section id="testimonials" className="mx-auto max-w-[1200px] px-4 py-14 sm:px-6 lg:px-8 lg:py-24">
      <h2 className="m-0 mb-9 text-[clamp(26px,4vw,32px)] font-semibold leading-tight text-pi-bright">
        {TESTIMONIALS_COPY.heading}
      </h2>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TESTIMONIALS_COPY.items.map((item) => (
          <div
            key={item.author}
            className="rounded-2xl border border-pi-border-strong bg-pi-panel p-[26px]"
          >
            <div
              aria-hidden="true"
              className="mb-4 bg-gradient-to-b from-pi-gold-start to-pi-gold bg-clip-text text-lg tracking-[2px] text-transparent"
            >
              ★★★★★
            </div>
            <p className="m-0 mb-[18px] text-[15px] leading-relaxed text-pi-text">
              &ldquo;{item.quote}&rdquo;
            </p>
            <div className="text-[13px] text-pi-dim">— {item.author}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
